import { useState } from "react";
import Spinner from "components/Spinner";
import LeadAccount from "./LeadAccount/LeadAccount";
import LeadAddress from "./LeadAddress/LeadAddress";
import LeadContact from "./LeadContact/LeadContact";
import LeadDetailsColumn from "./LeadDetailsColumn";
import LeadGeneralDetails from "./LeadGeneralDetails/LeadGeneralDetails";

function LeadDetails({ selectedLead, refreshFunc }) {
  const [active, setActive] = useState("lead_account");

  if (!selectedLead) {
    return (
      <div className="flex-grow-1 d-flex align-items-center justify-content-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="flex-grow-1 d-flex flex-column">
      <div className="d-flex">
        <div className=" d-flex flex-column flex-grow-1">
          <div
            className="flex-grow-1 bg-white shadow-sm px-4 py-3"
            style={{ borderRadius: 10 }}
          >
            <LeadContact selectedLead={selectedLead} />
          </div>
          <div
            className="flex-grow-1 d-flex flex-column mt-2"
            style={{ borderRadius: 10 }}
          >
            <ul className="nav nav-tabs nav-bordered mb-2  d-flex flex-grow-1">
              <li
                onClick={() => {
                  setActive("lead_account");
                }}
                className="nav-item"
              >
                <button
                  className={
                    active === "lead_account"
                      ? "nav-link rounded-0 active bg-primary text-white"
                      : "nav-link rounded-0"
                  }
                >
                  <span className="d-none d-md-block">Account Details</span>
                </button>
              </li>
              <li
                onClick={() => {
                  setActive("lead_address");
                }}
                className="nav-item"
              >
                <button
                  className={
                    active === "lead_address"
                      ? "nav-link rounded-0 active bg-primary text-white"
                      : "nav-link rounded-0"
                  }
                >
                  <span className="d-none d-md-block">Shipping Address</span>
                </button>
              </li>
            </ul>
            <div className="d-flex flex-grow-1">
              {active === "lead_account" && (
                <>
                  <div
                    className=" d-flex flex-grow-1 flex-column align-items-start w-50 py-2 bg-white shadow-sm px-4"
                    style={{ borderRadius: 10 }}
                  >
                    <LeadAccount
                      leadDetails={selectedLead}
                      refreshFunc={refreshFunc}
                    />
                  </div>
                  <div
                    className=" d-flex flex-grow-1 align-items-start w-50 py-2 ms-2 bg-white shadow-sm px-4"
                    style={{ borderRadius: 10 }}
                  >
                    <LeadGeneralDetails
                      leadDetails={selectedLead}
                      refreshFunc={refreshFunc}
                    />
                  </div>
                </>
              )}
              {active === "lead_address" && (
                <div
                  className=" d-flex flex-grow-1 bg-white shadow-sm px-4"
                  style={{ borderRadius: 10 }}
                >
                  <LeadAddress
                    selectedLead={selectedLead}
                    refreshFunc={refreshFunc}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div
          className="px-4 py-3 ms-3 bg-white shadow-sm "
          style={{ borderRadius: 10, minWidth: 320 }}
        >
          <LeadDetailsColumn
            leadDetails={selectedLead}
            refreshFunc={refreshFunc}
          />
        </div>
      </div>
    </div>
  );
}

export default LeadDetails;
